/**
 *
 * Asynchronously loads the component for ChatbotsForProfilerCandidate
 *
 */

import Loadable from 'react-loadable';

export default Loadable({
  loader: () => import('./index'),
  loading: () => null,
});



// WEBPACK FOOTER //
// ./src/ui/graphql/ChatbotsForProfilerCandidate/loadable.js